import { Link } from 'react-router-dom';

import links from '../../data/links';

import Navigation from '../navigation/navigation';

function Header(props) {
  return (
    <div className="c-header">
      <div className="c-header--title">
        <Link to="/">{props.title}</Link>
      </div>
      <Navigation links={links} />
    </div>
  );
}

export default Header;
